import { Box, Button, Grid } from "@material-ui/core";
import React from "react";
import { Header, Table } from "../../../../../components";
import {
  Access as SystemAccess,
  System,
  useRequestContext,
} from "../../../../../context";
import { EditModal } from "./edit-modal";
import { Access } from "./access";

type Props = {
  visible: boolean;
};

export type SelectedSystem = {
  system: System;
  access: SystemAccess;
};

export const AccessList: React.FC<Props> = (props) => {
  const [requestContextState, requestContextDispatch] = useRequestContext();
  const [selectedSystem, setSelectedSystem] = React.useState<
    SelectedSystem | undefined
  >(undefined);
  const [open, setOpen] = React.useState<boolean>(false);

  function handleAddMoreSystemsButtonClick(): void {
    requestContextDispatch({
      type: "set-step",
      name: "system-details",
      view: "select-systems",
    });
  }

  function handleSystemSelected(system: System, access: SystemAccess) {
    setOpen(true);
    setSelectedSystem({ system, access });
  }

  function handleClose() {
    setOpen(false);
    setSelectedSystem(undefined);
  }

  let editModal = null;

  if (!!selectedSystem) {
    editModal = (
      <EditModal
        open={open}
        selectedSystem={selectedSystem}
        onSubmit={(details: System, error: boolean) => {}}
        onClose={handleClose}
      />
    );
  }

  return props.visible ? (
    <React.Fragment>
      <Grid container spacing={2} component={Box} pt={4} pb={2}>
        <Grid item xs={12}>
          <Header title={`System(s)`}></Header>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} component={Box} display="flex">
          <Table
            columns={[
              { label: "Application / Device Type / Domain Account / LZ" },
              { label: "Domain / Host", width: "160px" },
              { label: "Environment", width: "100px" },
              { label: "Role", width: "100px" },
              { label: "Additional Form", width: "120px" },
              { label: "Edit", width: "65px" },
              { label: "Remove", width: "80px" },
            ]}
            rowHeight={43}
          >
            {requestContextState.values.systems.map((system) =>
              system.accesses.map((access: SystemAccess) => (
                <Access
                  key={[
                    system.application.id,
                    access.environment?.name,
                    access.role?.name,
                  ].join(":")}
                  access={access}
                  host={system.application.host}
                  name={system.application.name}
                  system={system}
                  onSystemSelected={handleSystemSelected}
                />
              ))
            )}
          </Table>
        </Grid>
        <Grid item xs={12}>
          <Button variant="outlined" onClick={handleAddMoreSystemsButtonClick}>
            + Add more systems
          </Button>
        </Grid>
      </Grid>
      {editModal}
    </React.Fragment>
  ) : null;
};
